export default "__VITE_PUBLIC_ASSET__f92575f0__"